import { ModelFactory } from "../../ModelFactory";
export class Contract {
  constructor(
    public readonly id: string,
    public readonly startedAt: Date,
    public readonly renewalAt: Date,
    public readonly billingPeriod: number,
    public readonly displayName: string,
    public readonly amount: number,
    public readonly cancelledAt: Date | null,
    public readonly tenantName?: string,
    public readonly lifetimeRevenue?: number,
  ) {
  }
}

class ContractFactory extends ModelFactory<Contract> {
  protected fromJson(json: any): Contract {
    return new Contract(
      json['id'],
      new Date(json['started_at']),
      new Date(json['renewal_at']),
      json['billing_period'],
      json['display_name'],
      json['amount'],
      json['cancelled_at'] ? new Date(json['cancelled_at']) : null,
      json['tenant_name'],
      json['lifetime_revenue'],
    );
  }
}
export const contractFactory = new ContractFactory();
